import axios from 'axios';
import api from './ApiAuthService';

export default class PerfilService {
  static async postDados(dados: any, url: any) {
    try {
      const response = await api.post(url, dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return error;
      throw error;
    }
  }

  static async updateDados(dados: any, url: any, id: any) {
    try {
      const response = await api.post(url + "/" + id, dados, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return error;
      throw error;
    }
  }

  static async updateUser(data: any) {
    try {
      const response = await api.put("/user/update", data);
      return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getUser() {
    try {
      let url = '/auth';
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getUserById(id: any) {
    try {
      let url = '/' + id + '/user-by-id';
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getList(rota: any, current_page: any, per_page: any, search: any) {
    try {
      let url = rota + "?page=" + current_page + "&per_page=" + per_page;

      if (search) {
        url += "&search=" + search;
      }
      
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async uploadFile(file: any, url: any) {
    try {
      const response = await api.post(url, file, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return error;
      throw error;
    }
  }

  static async uploadFilePerfil(file: any, url: any) {
    try {
      const response = await api.post(url, { image: file }, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      return error;
      throw error;
    }
  }

  static async removeFile(url: any) {
    try {
      const response = await api.post(url);
      return response.data;
    } catch (error) {
      return error;
      throw error;
    }
  }

  static async updatePassword( data: any) {
    try {
      const response = await api.post("/user/update-password", data);
      return response.data;
    } catch (error) {
      return error
    }
  }

  static async removeContact(id: any) {
    try {
      const response = await api.post("/posts/contact/" + id + "/delete");
      return response.data;
    } catch (error) {
      return error
    }
  }
}